import {createContext, useContext} from 'react';
import {TRootStore} from 'stores/RootStore';

const StoreContext = createContext<TRootStore>({} as TRootStore);

export const useStore = () => useContext(StoreContext);
export const StoreProvider = StoreContext.Provider;
